export default __webpack_public_path__ + "static/ARTE-4-8e29f512bd65bf16626ebc7475943f02.jpg";